import Power from '../../pages/power/Power'

import PrefixEnum from '../prefixes'

export default Object.freeze([{ path: PrefixEnum.POWER, component: Power }])
